import React, { CSSProperties, ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  noBorder?: boolean;
  isNoPadding?: boolean;
  isLargePadding?: boolean;
  isFullScreenSP?: boolean;
}

/**
 * テンプレパーツの大枠(表示用)
 */
export default function EditorFrame({
  children,
  className = "",
  style,
  isNoPadding = false,
  isFullScreenSP = false,
}: Props) {
  // テンプレパーツによって、緑枠線のpaddingがないものがあるためのpaddingなし用.
  const framePadding = isNoPadding ? "box-border" : "py-2";
  const wrapperPadding = isFullScreenSP ? "-mx-4" : "";

  return (
    <div
      className={`${wrapperPadding} h-full md:px-0 ${className}`}
      style={style}
    >
      <div className={`relative ${framePadding} w-full h-full`}>{children}</div>
    </div>
  );
}
